import {ReactElement, useState} from "react";
import GoVipLevelUpModal from "./modals/GoVipLevelUpModal";
import {WebsocketEvent, LevelUpWebhookResponse} from "@devour/client";
import useWebsocket from "@/hooks/useWebsocket";

function LevelUpHandler(): ReactElement {

    useWebsocket<LevelUpWebhookResponse>(WebsocketEvent.LEVELUP, handleNewLevel, true);

    const [
        userLevel,
        setUserLevel,
    ] = useState<LevelUpWebhookResponse>({
        userLevel: 1,
        usdReward: 0,
    });
    const [
        showGoVIPLevelUpModal,
        setShowGoVIPLevelUpModal,
    ] = useState(false);

    function handleNewLevel(data: LevelUpWebhookResponse) {
        setUserLevel(data);
        setShowGoVIPLevelUpModal(true);
    }

    function toggleShowLevelUpModal(): void {
        setShowGoVIPLevelUpModal(s => !s);
    }

    return (
        <GoVipLevelUpModal
            isOpen={showGoVIPLevelUpModal}
            toggle={toggleShowLevelUpModal}
            level={userLevel.userLevel}
            dpayGained={userLevel.usdReward}
        />
    );
}

export default LevelUpHandler;
